import { styled } from '@styledComponents';
import { themeMediaQuery } from '@utils/styledTheme.util';
import { TextPairing } from '@components/TextPairing';
import { GetStartedButton } from '@components/GetStartedButton/GetStartedButton';

export const StyledTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 512px;
  }
  .text-pairing-body {
    max-width: 460px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      width: 314px;
      max-width: 314px;
    }
  }
  ${themeMediaQuery('sm')} {
    .text-pairing-title {
      max-width: 360px;
    }
    .text-pairing-body {
      max-width: 364px;
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 470px;
    }
  }
`;

export const StyledGetStartedButton = styled(GetStartedButton)`
  background: transparent;
`;
